import React, { Component } from "react";
import PropTypes from "prop-types";
import { Row, Col } from "antd";
import "./RcuControl.css";

class RcuControlNoChild extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  // 将 Title 转换为显示文本
  getTitleText = (title) => {
    const titleMap = {
      "make.up.room": "Make Up Room",
      "do.not.disturb": "Do Not Disturb",
      "master": "Master",
      "master.off": "Master Off",
      "bathroom": "Bathroom",
      "bathroom.m": "Master Bathroom",
      "bathroom.2": "Bathroom 2",
      "bedroom": "Bedroom",
      "bedroom.m": "Master Bedroom",
      "bedroom.2": "Bedroom 2",
      "bedroom.m.table": "Table",
      "livingroom": "Living Room",
      "diningroom": "Dining Room",
      "ac": "Air Conditioning",
      "blind.up": "Blind Up",
      "blind.down": "Blind Down",
      "sheer.open": "Sheer Open",
      "sheer.close": "Sheer Close",
      "table": "Table",
      "closet": "Closet",
      "pantry": "Pantry",
      "working.table": "Working Table",
      "utility": "Utility",
      "balcony": "Balcony",
    };
    return titleMap[title] || title;
  };

  render() {
    const { ColSpan, Title, Icon, isOn, onClick, ShowSwitchText } = this.props;

    return (
      <Col span={ColSpan ?? 12} className="col-rcu-menu-wrap">
        <Row>
          <Col span={24} className="col-rcu-menu" onClick={() => onClick()}>
            <div
              className={isOn ? "div-rcu-menu div-rcu-menu-on" : "div-rcu-menu"}
            >
              <img
                src={require(`../../assets/image/client_controller/${Icon}`)}
                alt="Icon"
              />
              <div className="div-rcu-menu-info">
                <div className="div-rcu-menu-info-title">
                  {this.getTitleText(Title)}
                </div>
                {ShowSwitchText && (
                  <div className="div-rcu-menu-info-control">
                    {isOn ? "On" : "Off"}
                  </div>
                )}
              </div>
            </div>
          </Col>
        </Row>
      </Col>
    );
  }
}

RcuControlNoChild.propTypes = {
  ColSpan: PropTypes.number,
  Title: PropTypes.string,
  Icon: PropTypes.string,
  isOn: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  ShowSwitchText: PropTypes.bool,
};

export default RcuControlNoChild;
